import { InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { AiCreditTransaction } from './AiCreditTransaction'

/**
 * Args for the `DataTable`-facing `aiCreditTransactionList` read. The owner scope rides inside
 * `filter` as an ordinary `filter.ownerId` field and is `typeof`-guarded in
 * `AiCreditTransactionListService.scopedFilter`, so it is no longer a top-level arg.
 */
@InputType()
export class GetAiCreditTransactionListArgs extends QueryArgs<AiCreditTransaction> {}
